// Structura meniului din stanga. Fiecare element e fie o legatura (url), fie un
// grup (copii). `acces` restrange elementul (si tot ce e sub el) la un rol:
//   'avizari' - admin (0) si Avizari (99), vezi AuthStore.isAvizari
//   'admin'   - doar admin (0)
// Fara `acces` elementul e vizibil pentru orice utilizator autentificat.
export type NavAcces = 'avizari' | 'admin';

export interface NavElement {
  id: string;
  titlu: string;
  icon?: string;
  url?: string;
  copii?: NavElement[];
  acces?: NavAcces;
}

export interface NavDrepturi {
  admin: boolean;
  avizari: boolean;
}

export const MENIU_STANGA: NavElement[] = [
  { id: 'home', titlu: 'Pagina principală', icon: 'home', url: '/dashboard' },
  { id: 'medic', titlu: 'Medic', icon: 'assignment_ind', url: '/medic' },
  {
    id: 'cmj',
    titlu: 'C.M.J',
    icon: 'location_city',
    copii: [
      { id: 'cmj-transfer', titlu: 'Transfer', url: '/cmj/cmj-transfer' },
      { id: 'cmj-cpc', titlu: 'Cert. Prof. Curent', url: '/cmj/cert-prof-curent' },
      { id: 'cmj-rapoarte', titlu: 'Rapoarte', url: '/cmj/rapoarte' },
      { id: 'cmj-configurare', titlu: 'Configurare', url: '/cmj/configurare' }
    ]
  },
  // Alerte IMI e in radacina pentru toti; CMJ isi vede doar dosarele proprii
  { id: 'alerte-imi', titlu: 'Alerte IMI', icon: 'notification_important', url: '/avizari-cmr/imi' },
  {
    id: 'avizari-cmr',
    titlu: 'Avizări CMR',
    icon: 'verified_user',
    acces: 'avizari',
    copii: [
      { id: 'avizari-cmr-nemembru', titlu: 'Adeverință nemembru', url: '/avizari-cmr/nemembru' }
    ]
  },
  {
    id: 'admin',
    titlu: 'Admin',
    icon: 'star_border',
    acces: 'admin',
    copii: [
      { id: 'admin-users', titlu: 'Utilizatori', url: '/admin/users' },
      { id: 'admin-registre', titlu: 'Registre', url: '/admin/registre' },
      {
        id: 'admin-medic',
        titlu: 'Medic',
        copii: [
          { id: 'admin-medic-cuim', titlu: 'CUIM', url: '/admin/medic/cuim' },
          { id: 'admin-medic-facultate', titlu: 'Facultate', url: '/admin/medic/facultate' },
          { id: 'admin-medic-status', titlu: 'Status', url: '/admin/medic/status' },
          { id: 'admin-medic-reg-med', titlu: 'Registru Public', url: '/admin/medic/reg-med' },
          { id: 'admin-medic-cmmb', titlu: 'CMMB actualizare', url: '/admin/medic/cmmb' },
          { id: 'admin-medic-aviz', titlu: 'Aviz', url: '/admin/medic/doc/aviz' }
        ]
      }
    ]
  }
];

/** Meniul vizibil pentru drepturile date: se scot elementele fara acces si grupurile ramase goale. */
export function meniuPentru(drepturi: NavDrepturi, elemente: NavElement[] = MENIU_STANGA): NavElement[] {
  return elemente
    .filter(element => !element.acces || drepturi[element.acces])
    .map(element => element.copii ? { ...element, copii: meniuPentru(drepturi, element.copii) } : element)
    .filter(element => !element.copii || element.copii.length > 0);
}

/** Toate url-urile din subarborele unui element (pentru a sti daca un grup contine pagina curenta). */
export function urluriDin(element: NavElement): string[] {
  const proprii = element.url ? [element.url] : [];
  return proprii.concat(...(element.copii ?? []).map(urluriDin));
}
